import {addAnimalsFromCsvSaga} from './add-animals-from-csv-saga';
import {addAnimalsFromDBSaga} from './add-animals-from-db-saga';
import {addAnimalsSaga} from './add-animals-saga';
import {confirmOverrideAnimalListFromIdsSaga} from './confirm-override-animal-list-from-ids-saga';
import {confirmOverrideAnimalListSaga} from './confirm-override-animal-list-saga';
import {createAnimalListFromIdsSaga} from './create-animal-list-from-ids-saga';
import {createAnimalListSaga} from './create-animal-list-saga';
import {deleteAnimalListSaga} from './delete-animal-list-saga';
import {deleteAnimalsSaga} from './delete-animals-saga';
import {exportCabAnimalsSaga} from './export-cab-animals-saga';
import {filterCabCalvesSaga} from './filter-cab-calves-saga';
import {filterCabFemalesSaga} from './filter-cab-females-saga';
import {getAnimalListsSaga} from './get-animal-lists-saga';
import {getAnimalsCountSaga} from './get-animals-count';
import {getAnimalsForPrint} from './get-animals-for-print';
import {getAvailableAnimalsSaga} from './get-available-animals-saga';
import {getBreederOptions} from './get-breeder-options';
import {getBreedingFemalesForPrint} from './get-breeding-females-for-print';
import {getCabCalvesSaga} from './get-cab-calves-saga';
import {getCabFemalesSaga} from './get-cab-females-saga';
import {getCalfBrowserSaga} from './get-calf-browser-saga';
import {getCalvesCsvSaga} from './get-calves-csv-saga';
import {getCowBrowserSaga} from './get-cow-browser-saga';
import {getCowsCsvSaga} from './get-cows-csv-saga';
import {getDistrictCodesOptionsSaga} from './get-district-codes-options';
import {getFarmOptionsSaga} from './get-farm-options';
import {getMotherHuidSaga} from './get-mother-huid-saga';
import {getOrganizationCenterInsOptionsSaga} from './get-oragnization-center-ins-options';
import {getOrganizationCenterPtOptionsSaga} from './get-oragnization-center-pt-options';
import {getOrganizationInsOptionsSaga} from './get-oragnization-ins-options';
import {getOrganizationPtOptionsSaga} from './get-oragnization-pt-options';
import {getStableOptionsSaga} from './get-stable-options';
import {getStablesCsvSaga} from './get-stables-csv-saga';
import {getStablesDataSaga} from './get-stables-saga';
import {renameAnimalListSaga} from './rename-animal-list-saga';
import {submitPrintModalSaga} from './submit-print-modal';

/**
 * Root saga registrations for the animal-browser module.
 *
 * @returns All saga watchers wired into the animal-browser feature.
 */
export const animalBrowserSagas = [
    getStablesDataSaga,
    getCowBrowserSaga,
    getCalfBrowserSaga,
    submitPrintModalSaga,
    getCalvesCsvSaga,
    getAnimalsForPrint,
    getBreedingFemalesForPrint,
    getCowsCsvSaga,
    getStablesCsvSaga,
    getCabFemalesSaga,
    filterCabFemalesSaga,
    exportCabAnimalsSaga,
    getCabCalvesSaga,
    filterCabCalvesSaga,
    getOrganizationPtOptionsSaga,
    getOrganizationInsOptionsSaga,
    getDistrictCodesOptionsSaga,
    getBreederOptions,
    getFarmOptionsSaga,
    getStableOptionsSaga,
    getOrganizationCenterInsOptionsSaga,
    getOrganizationCenterPtOptionsSaga,
    getAnimalListsSaga,
    renameAnimalListSaga,
    createAnimalListSaga,
    deleteAnimalListSaga,
    confirmOverrideAnimalListSaga,
    confirmOverrideAnimalListFromIdsSaga,
    createAnimalListFromIdsSaga,
    getAvailableAnimalsSaga,
    addAnimalsSaga,
    addAnimalsFromCsvSaga,
    addAnimalsFromDBSaga,
    getAnimalsCountSaga,
    deleteAnimalsSaga,
    getMotherHuidSaga,
];
